import React, { FC, useState } from 'react';
import classes from './styles/index.module.scss';
import { MovingGradient } from '../../../../components/MovingGradient';
import { FlexGrid } from '../../../../components/FlexGrid';
import { CloseTiny } from '../../../../components/Icons/CloseTiny';

const minWidth = 30;
const maxWidth = 140;

export const ListFilterBreadcrumbTempItem: FC = () => {
	const [gradientWidth] = useState(() => {
		return Math.floor(Math.random() * (maxWidth - minWidth + 1)) + minWidth;
	});

	return (
		<button
			type='button'
			className={classes.listFilterBreadcrumbItem}
			disabled
		>
			<FlexGrid
				gap='scanty'
				center
			>
				<MovingGradient
					height='4px'
					width={`${gradientWidth}px`}
					className={classes.movingGradient}
				/>
				<CloseTiny className={classes.removeIcon} />
			</FlexGrid>
		</button>
	);
};
